var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2391 29.8727V25.5494L25.1651 16.6567L29.4884 20.9467L20.5624 29.8727H16.2391ZM18.3984 27.7134H19.6651L23.6667 23.6784L23.0667 23.0451L22.4334 22.4451L18.3984 26.4467V27.7134ZM2.66675 29.8727V2.66406H16.3827L24.5421 10.8234V14.7041H21.5087V12.3641H14.8421V5.6974H5.70008V26.8394H13.5724V29.8727H2.66675ZM23.0667 23.0451L22.4334 22.4451L23.6667 23.6784L23.0667 23.0451Z",
    fill: "url(#paint0_linear_6627_173802)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6627_173802",
    x1: 2.66675,
    y1: 2.66406,
    x2: 29.8726,
    y2: 29.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224762,
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852864,
    stopColor: "#1D5AE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleIcon);
export default __webpack_public_path__ + "static/media/TitleIcon.ab94611f371538425ec95efab3daf6a7.svg";
export { ForwardRef as ReactComponent };